import React from "react";
import { Stack } from "@mui/material";

import { HistoryTimeline } from "../../../components";
import { useGetQuoteHistory } from "../../../hooks/react-query/useSalesData";
import { QUOTE_STAGE_LABELS } from "../../../constants/salesStages";

const getStageLabel = (stage) =>
  QUOTE_STAGE_LABELS.find((s) => s.id === stage)?.label || `Stage ${stage}`;

const getStageFlow = (stage) =>
  QUOTE_STAGE_LABELS.find((s) => s.id === stage)?.flow || "grey";

const HistoryTab = ({ quoteId }) => {
  const { data: history } = useGetQuoteHistory(quoteId);

  return (
    <Stack
      sx={{
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        overflowX: "hidden",
        "::-webkit-scrollbar": {
          display: "none !important",
        },
      }}
    >
      <HistoryTimeline
        history={history || []}
        getStageLabel={getStageLabel}
        getStageFlow={getStageFlow}
      />
    </Stack>
  );
};

export default HistoryTab;
